module.exports = __webpack_public_path__ + "static/img/produce02.567445a.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce02.png
// module id = 132
// module chunks = 4